<template>
    <div class="WebhooksSection" data-test-id="WebhooksSection__sectionContainer">
        <WebhookSectionsTable
            :webhooks="webhooks"
            :webhook-types="webhookTypes"
            :updating="updating"
            :deleting="deleting"
            @change="$emit('change', $event)"
            @delete="$emit('delete', $event)"
        />
    </div>
</template>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';

    import { InsuranceWebhook, InsuranceWebhookType } from '@evidentid/tprm-portal-lib/models/api-settings';

    import WebhookSectionsTable from '@/modules/api-settings/components/webhooks-table/WebhooksTable.vue';

    export default defineComponent({
        name: 'WebhooksSection',
        components: { WebhookSectionsTable },
        props: {
            webhooks: {
                type: Array as PropType<InsuranceWebhook[]>,
                default: (): InsuranceWebhook[] => [] as InsuranceWebhook[],
            },
            webhookTypes: {
                type: Array as PropType<InsuranceWebhookType[]>,
                default: (): InsuranceWebhookType[] => [] as InsuranceWebhookType[],
            },
            updating: {
                type: Boolean as PropType<boolean>,
                default: false,
            },
            deleting: {
                type: Boolean as PropType<boolean>,
                default: false,
            },
        },
        emits: [ 'change', 'delete' ],
    });
</script>
